<template>
    <div>
        <input type='hidden' v-model='$parent.item.id'>

        <div class="form-group">
            <label for='name'>{{ $t('translations.name')}} <span class="required-field">*</span></label>
            <input type='text' v-model='$parent.item.name' class='form-control'>
        </div>

        <div class="form-group border-bottom bg-light d-flex justify-content-between col-24 p-1">
            <label class="form-check-label p-1 pl-2" >
                {{ autobrand('translations.group_can_have_requests_assigned')}}
            </label>
            <toggle-button sync v-model='$parent.item.group_assignable' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
        </div>

        <div class="form-group border-bottom bg-light d-flex justify-content-between col-24 p-1">
            <label class="form-check-label p-1 pl-2" >
                {{ autobrand('translations.members_can_have_requests_assigned')}}
            </label>
            <toggle-button sync v-model='$parent.item.members_assignable' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
        </div>

        <div class="form-group border-bottom bg-light d-flex justify-content-between col-24 p-1">
            <label class="form-check-label p-1 pl-2" >
                {{ autobrand('translations.patients_can_choose_group_members')}}
            </label>
            <toggle-button sync v-model='$parent.item.patient_requestable' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
        </div>

        <div class="form-group border-bottom bg-light d-flex justify-content-between col-24 p-1">
            <label class="form-check-label p-1 pl-2" >
                {{ $t('translations.can_complete_on_behalf_of_another')}}
            </label>
            <toggle-button sync v-model='$parent.item.completes_on_behalf_of' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
        </div>

        <!-- <div class="form-group border-bottom bg-light d-flex justify-content-between col-24 p-1">
            <label class="form-check-label p-1 pl-2" >
                {{ $t('translations.capacity')}}
            </label>
            <input class="form-control-inline" type="number" min="0" v-model='$parent.item.capacity'>
        </div> -->
        

        <div class="form-group" v-if='Array.isArray($parent.item.users)'>
    		<label for='name'>{{ $t('translations.members')}}</label>
            <template v-for="value in $parent.related_data.staff">

            <div class="ml-4 form-check" :key="value.id">
                <input class="form-check-input" type="checkbox" :id='"defaultCheck" + value.id' :value="value.id"  v-model='$parent.item.users' >
                <label class="form-check-label" :for='"defaultCheck" + value.id'>
                    {{value.name}}
                </label>
            </div>

    		<!-- <select v-if='Array.isArray($parent.item.users)' v-model='$parent.item.users' class='form-control' multiple=multiple size="20">
                <option v-for="value in $parent.related_data.staff" :value="value.id" :key="value.id">{{value.name}}</option>
            </select> -->

            </template>
    	</div>

    </div>
</template>

<script>
	export default {
		props: [
		],
		data: function(){
			return {
			};
		},
        mounted() {

        },
        computed: {
            // usergroups: {
            //     get() {
            //         var value = [];
            //         for(var index in this.$parent.item.usersusergroupindex) {
            //             value.push(this.$parent.item.usersusergroup[index].user_id);
            //         }
            //         console.log(value);
            //         return value;
            //     },
            //     set() {
            //         this.$parent.item
            //     }
            // }
        },
        methods: {
            loadItem(id) {

                this.$parent.setLoading(true);
                axios.get(this.$parent.route + '/' + id).then((res) => {
                    this.$parent.item = res.data[this.$parent.model];
                    this.$parent.item.users = [];
                    for(var index in this.$parent.item.usersusergroup) {
                        this.$parent.item.users.push(this.$parent.item.usersusergroup[index].user_id);
                    }
                    this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
                    this.$parent.setLoading(false);
                    //alert(JSON.stringify(this.$parent.item.users, null, 2));
				}).catch((error) => {
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "load");
                    this.$router.push({path: "/" + this.$parent.event + "-list"});
                });
            },
            getName() {
                return this.$parent.item.name;
            }
        }

    }
</script>
